import { Send } from "lucide-react";
import { useState } from "react";

import { useConversationState } from "../conversation-state-provider";
import { ChatOptionComponentProps } from "../lookup";
import { SelfAdjustingTextarea } from "~/components/input/self-adjusting-textarea";
import { cn } from "~/util/cn";

export const TextDrawerSimple: React.FC<ChatOptionComponentProps> = ({
  sendResponse,
}) => {
  const [message, setMessage] = useState("");
  const { isChatBusy } = useConversationState();

  const submit = () => {
    const { hasResponseBeenSent } = sendResponse({ message, selection: [] });
    if (hasResponseBeenSent) {
      setMessage("");
    }
  };

  return (
    <div
      className={cn(
        "mx-auto sm:mb-4",
        "w-full bg-base-100 px-4 py-3",
        "border-x border-t border-t-neutral-200 sm:border-b",
        "rounded-t-2xl sm:rounded-b-2xl",
        "max-w-screen-sm",
        "flex flex-col items-stretch",
      )}
    >
      <SelfAdjustingTextarea
        text={message}
        setText={setMessage}
        className="max-h-40 w-full resize-none appearance-none break-words bg-transparent leading-6 text-mama-default-primary caret-mama-default-primary outline-none"
        onEnterPressed={submit}
      />
      <button
        title="send"
        className="btn-neutral btn-sm btn ml-auto h-10 w-12 transition-opacity duration-500 ease-in-out disabled:bg-neutral-700 disabled:text-neutral-100 disabled:opacity-40"
        onClick={() => {
          if (message.length == 0) {
            return;
          }

          submit();
        }}
        disabled={isChatBusy}
      >
        <Send width={24} className="text-inherit" />
      </button>
    </div>
  );
};
